import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import AuthProvider from '../../providers/auth.provider';
import { config } from '../../config';

const liffId = config.liff_id.policy;

const Policy = loadable(() => import('./Policy'), { fallback: null });

const PolicyDetail = loadable(() => import('./PolicyDetail'), {
    fallback: null,
});
const TtbTheTreasureTC = loadable(
    () => import('./ttbTheTreasure/TtbTheTeasureTC'),
    { fallback: null },
);
const TtbTheTreasureForm = loadable(
    () => import('./ttbTheTreasure/TtbTheTreasureForm'),
    { fallback: null },
);
const TtbTheTreasureComplete = loadable(
    () => import('./ttbTheTreasure/TtbTheTreasureComplete'),
    { fallback: null },
);
const TtbTheTreasureSummary = loadable(
    () => import('./ttbTheTreasure/TtbTheTreasureSummary'),
    { fallback: null },
);
const TtbTheTreasureOtp = loadable(
    () => import('./ttbTheTreasure/TtbTheTreasureOtp'),
    { fallback: null },
);

const PruSecureSaverTC = loadable(
    () => import('./pruSecureSaver/PruSecureSaverTC'),
    { fallback: null },
);
const PruSecureSaverForm = loadable(
    () => import('./pruSecureSaver/PruSecureSaverForm'),
    { fallback: null },
);
const PruSecureSaverComplete = loadable(
    () => import('./pruSecureSaver/PruSecureSaverComplete'),
    { fallback: null },
);
const PruSecureSaverSummary = loadable(
    () => import('./pruSecureSaver/PruSecureSaverSummary'),
    { fallback: null },
);
const PruSecureSaverOtp = loadable(
    () => import('./pruSecureSaver/PruSecureSaverOtp'),
    { fallback: null },
);
const NotFound = loadable(() => import('../NotFound'), { fallback: null });


export default function PolicyRoute() {
    return (
        <Routes>
            <Route path="/" element={<Policy />} />
            <Route path="Mypolicy-detail" element={<PolicyDetail />} />

            {/* TtbTheTreasure routes */}
            <Route path="consent-TC" element={<AuthProvider liffId={liffId}><TtbTheTreasureTC /></AuthProvider>} />
            <Route path="ttb-the-treasure/form" element={<TtbTheTreasureForm />} />
            <Route path="ttb-the-treasure/complete" element={<TtbTheTreasureComplete />} />
            <Route path="ttb-the-treasure/summary" element={<TtbTheTreasureSummary />} />
            <Route path="ttb-the-treasure/confirmation-otp" element={<TtbTheTreasureOtp />} />

            {/* PruSecureSaver routes */}
            <Route path="consent-pru-secure-saver-TC" element={<AuthProvider liffId={liffId}><PruSecureSaverTC /></AuthProvider>} />
            <Route path="pru-secure-saver/form" element={<PruSecureSaverForm />} />
            <Route path="pru-secure-saver/complete" element={<PruSecureSaverComplete />} />
            <Route path="pru-secure-saver/summary" element={<PruSecureSaverSummary />} />
            <Route path="pru-secure-saver/confirmation-otp" element={<PruSecureSaverOtp />} />

            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
